/* Mark's Outdoors header behavior — vanilla port of site-nav.tsx.
   Auto-hide on scroll (headroom), transparent-over-hero via #hero-sentinel,
   hover-intent mega menu, mobile full-screen drill-down. No dependencies. */
(function () {
  'use strict';

  var header = document.querySelector('.mo-header');
  if (!header) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mega = header.querySelector('.mo-mega');
  var megaToggle = header.querySelector('[data-mega-toggle]');
  var drill = document.querySelector('.mo-drill');
  var burger = header.querySelector('[data-drill-open-btn]');
  var drillOpener = null;

  var isDesktop = function () {
    return window.matchMedia('(min-width: 1024px)').matches;
  };

  /* ---------- Transparent-over-hero vs solid ----------
     Homepage hero renders <div id="hero-sentinel"> at its bottom edge and adds
     .mo-has-hero to <body>. Off-hero pages: always solid. */
  var sentinel = document.getElementById('hero-sentinel');
  function setOverHero(over) {
    header.classList.toggle('is-over-hero', over && !megaOpen());
  }
  if (sentinel) {
    setOverHero(true);
    var io = new IntersectionObserver(
      function (entries) {
        // Solid once the sentinel has scrolled above the nav (~72px tall).
        setOverHero(entries[0].boundingClientRect.top >= 72);
      },
      { threshold: [0] }
    );
    io.observe(sentinel);
  } else if (document.body.classList.contains('mo-has-hero')) {
    // Fallback: treat the hero as roughly one viewport tall.
    var onHeroScroll = function () {
      setOverHero(window.scrollY <= window.innerHeight * 0.6);
    };
    onHeroScroll();
    window.addEventListener('scroll', onHeroScroll, { passive: true });
  } else {
    setOverHero(false);
  }

  /* ---------- Auto-hide on scroll direction (headroom) ---------- */
  var lastY = window.scrollY;
  var ticking = false;
  var REVEAL_ZONE = 100; // never hide within this many px of the top
  var DELTA = 6; // ignore movements smaller than this

  function anyMenuOpen() {
    return megaOpen() || (drill && drill.classList.contains('is-open'));
  }
  function update() {
    ticking = false;
    var y = window.scrollY;
    if (anyMenuOpen() || y <= REVEAL_ZONE) {
      header.classList.remove('is-hidden');
      lastY = y;
      return;
    }
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;
    header.classList.toggle('is-hidden', diff > 0);
    lastY = y;
  }
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );

  /* ---------- Desktop mega menu (hover intent + click + keyboard) ---------- */
  var openTimer = null;
  var closeTimer = null;

  function megaOpen() {
    return !!(mega && mega.classList.contains('is-open'));
  }
  function openNow() {
    if (!mega) return;
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    mega.classList.add('is-open');
    megaToggle.setAttribute('aria-expanded', 'true');
    header.classList.remove('is-hidden', 'is-over-hero');
  }
  function closeNow() {
    if (!mega) return;
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    mega.classList.remove('is-open');
    megaToggle.setAttribute('aria-expanded', 'false');
    if (sentinel) {
      setOverHero(sentinel.getBoundingClientRect().top >= 72);
    }
  }
  function scheduleOpen() {
    if (!isDesktop()) return; // touch taps fire mouseenter; drill handles mobile
    window.clearTimeout(closeTimer);
    if (megaOpen()) return;
    window.clearTimeout(openTimer);
    openTimer = window.setTimeout(openNow, 150);
  }
  function scheduleClose() {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(closeNow, 160);
  }

  if (megaToggle && mega) {
    var toggleWrap = megaToggle.parentElement;
    toggleWrap.addEventListener('mouseenter', scheduleOpen);
    toggleWrap.addEventListener('mouseleave', scheduleClose);
    mega.addEventListener('mouseenter', openNow);
    mega.addEventListener('mouseleave', scheduleClose);
    megaToggle.addEventListener('click', function () {
      if (!isDesktop()) {
        openDrill();
        return;
      }
      if (megaOpen()) closeNow();
      else openNow();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && megaOpen()) {
        closeNow();
        megaToggle.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (megaOpen() && !mega.contains(e.target) && !toggleWrap.contains(e.target)) {
        closeNow();
      }
    });
    mega.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeNow();
    });
  }

  /* ---------- Mobile drill-down ---------- */
  function openDrill() {
    if (!drill) return;
    drillOpener = document.activeElement;
    drill.classList.add('is-open');
    header.classList.remove('is-hidden');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = drill.querySelector('.mo-drill__close');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrill() {
    if (!drill) return;
    drill.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (burger) burger.setAttribute('aria-expanded', 'false');
    showDeptList();
    if (drillOpener && drillOpener.focus) drillOpener.focus();
  }
  function showDeptList() {
    drill.querySelector('[data-drill-root]').hidden = false;
    drill.querySelectorAll('[data-drill-pane]').forEach(function (p) { p.hidden = true; });
    drill.querySelector('.mo-drill__back').hidden = true;
    drill.querySelector('.mo-drill__title').hidden = false;
  }
  function showDept(id) {
    drill.querySelector('[data-drill-root]').hidden = true;
    drill.querySelectorAll('[data-drill-pane]').forEach(function (p) {
      p.hidden = p.getAttribute('data-drill-pane') !== id;
    });
    drill.querySelector('.mo-drill__back').hidden = false;
    drill.querySelector('.mo-drill__title').hidden = true;
  }

  if (burger) burger.addEventListener('click', openDrill);

  if (drill) {
    drill.querySelector('.mo-drill__close').addEventListener('click', closeDrill);
    drill.querySelector('.mo-drill__back').addEventListener('click', showDeptList);
    drill.querySelectorAll('[data-drill-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showDept(btn.getAttribute('data-drill-open'));
      });
    });
    drill.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeDrill();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drill.classList.contains('is-open')) closeDrill();
    });
  }
})();
